import { rem } from 'polished'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import Switch from 'LuxKit/Switch/Switch'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  toggled: boolean
  onToggle: () => void
  label?: string
  name?: string
}

const Container = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: ${rem(24)};
`

const SwitchButtonContainer = styled.div`
  margin-right: ${rem(16)};
`

function ConfirmedBooking({
  toggled,
  onToggle,
  label,
  name,
}: Props) {
  const intl = useIntl()

  const markAsBookedLabel = intl.formatMessage({
    id: 'nlhY_uHRiIlYXHgxqTiM',
    defaultMessage: 'Mark as booked',
    description: 'Toggle label to mark a trip item as booked/confirmed',
  })

  const displayLabel = label ?? markAsBookedLabel

  return (
    <Container>
      <SwitchButtonContainer>
        <Switch
          checked={toggled}
          onChange={onToggle}
          name={`${name}::boolean`}
          aria-label={markAsBookedLabel}
        />
      </SwitchButtonContainer>
      <BodyText variant="large" colour="normal-contrast">
        {displayLabel}
      </BodyText>
    </Container>
  )
}

export default memo(ConfirmedBooking)
